import { BoundTextField } from "lib/@components/binding/bound-components"
import { DialogContent, DialogTitle, Typography } from "@mui/material"
import { PropertyBox } from "lib/@components/property-box"
import { DataInputDialog } from "lib/@dialogs/data-input-dialog"
import { ScheduleCodeField } from "./schedule-code-field"
import { ScheduleTypesAutocomplete } from "./schedule-types-autocomplete"
import { ScheduleGroupsAutocomplete } from "./schedule-groups-autocomplete"
import { UnitOfMeasureSelect } from "./unit-of-measure-select"

export function CreateScheduleDialog() {
    return (
        <DataInputDialog
            initialValue={getInitialCreateAuthoringScheduleValue()}
            okCaption="OK"
            okDisabled={isSubmitDisabled}
        >
            <DialogTitle>Create New Schedule</DialogTitle>
            <DialogContent>
                <PropertyBox pt={1} spacing={0} data-cy="create-schedule-dialog">
                    <ScheduleCodeField />
                    <BoundTextField sx={{ mt: 2 }} field="title" label="Title" yup="string.required.trim" />
                    <ScheduleTypesAutocomplete />
                    <ScheduleGroupsAutocomplete />
                    <UnitOfMeasureSelect />
                    <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>
                        Schedule type, groups, and unit of measure can all be changed after creation in the schedule
                        editor.
                    </Typography>
                </PropertyBox>
            </DialogContent>
        </DataInputDialog>
    )
}

function isSubmitDisabled(schedule) {
    return (
        !(
            schedule?.code?.trim() &&
            schedule?.title?.trim() &&
            schedule?.legacyScheduleTypes?.length > 0 &&
            schedule?.legacyScheduleGroups?.length > 0
        ) || !!schedule?._codeUnavailable
    )
}

function getInitialCreateAuthoringScheduleValue() {
    return {
        code: "",
        title: "",
        legacyScheduleTypes: [],
        legacyScheduleGroups: [],
        unitOfMeasure: "Nr",
    }
}
